import { gsap, ScrollTrigger } from '../globals/gsap';

class ScrollAnimations {

  stateClasses = {
    inView: 'in-view',
  };

  constructor(scope)  {
    this.scope = scope;
    this.$scrollAnimations = $(scope).find('[data-scroll]');
    this.hasHash = window.location.hash !== '';
    this.init();
  }

  init = () => {
    this.initScrollReveal();
  }

  initScrollReveal = () => {
    if(this.$scrollAnimations.length) {
      ScrollTrigger.batch(this.$scrollAnimations, {
        onEnter: batch => {
          gsap.utils.toArray(batch).forEach((element, i) => {
            requestAnimationFrame(() => {
              gsap.to(element, {
                delay: this.hasHash ? 0 : i * 0.15,
                onStart: () =>  {
                  element.classList.add(this.stateClasses.inView);
                }
              });
            });
          });
        },
        start: 'top 80%',
        markers: false,
        once: true,
      })
    }
  }
}

export default ScrollAnimations;